import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import Table from './components/table/main';
import CheckboxForm from './components/form/main';
import Filters from '../shared/fixed-filters/main';
import Calendar from '../shared/calendar/main';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content conversions-garant-approve-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Top offers')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<CheckboxForm {...props} initialValues={{ are_new_offers_included: props.isIncludedNewOffers }} />
						<div className="ui-control-bar__item-position">
							<Calendar
								{...props.calendar}
								onInit={props.calendarInit}
								onToggle={props.calendarToggle}
								onChange={props.calendarChange}
								onApply={props.calendarApply}
								intl={props.intl}
							/>
						</div>
						<div className="display-flex">
							<button
								className="ui-btn ui-btn-primary save margin-0-10"
								onClick={props.apply}
							>
								{props.intl('Apply')}
							</button>
							<button className="ui-btn ui-btn-primary apply" onClick={props.exportCsv}>
								{props.intl('Export')}
							</button>
						</div>
					</div>
					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		isIncludedNewOffers: selectors.getIsIncludedNewOffers(state),
		intl: selectors.getIntl(state),
		table: selectors.getTable(state),
		filters: selectors.getFilters(state),
		topOffersCheckboxes: selectors.getTopOffersCheckbox(state),
		progressBar: selectors.getProgressBar(state),
		calendar: selectors.getCalendar(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-offers/main.js